import React from "react";

import fireTv from "../../../resources/fire_tv.png";

import type { JSX } from "react";

interface IFireTvIcon {
  className?: string;
}

function FireTvIcon(props: IFireTvIcon): JSX.Element {
  const { className } = props;
  return <img alt="fire-tv-icon" className={className} src={fireTv} />;
}

export default FireTvIcon;
